import store from '@/store'
import { LayoutSavitarna } from '@/components/layouts'
import { LayoutNtrPaslaugos } from '@/components/layouts'

export const savitarnaRoute = [
  {
    path: '*',
    // component: () => import('@/views/error/NotFound.vue'),
    redirect: { name: 'home' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/Login.vue'),
    meta: {
      title: 'Login',
      open: true,
    },
    hidden: true,
  },
  {
    path: '/ipasas',
    name: 'ipasasAuth',
    meta: {
      title: 'iPAS',
      open: true,
    },
    component: () => import('@/views/auth/IpasasAuth.vue'),
  },
  {
    path: '/krepselis/:paslaugaID/:uzsakymasID',
    name: 'krepselis',
    meta: {
      title: 'Krepšelis',
      open: true,
    },
    component: () => import('@/views/Krepselis.vue'),
  },
  {
    path: '/ntr-paslaugos/ntr-krepselis/:paslaugaID/:uzsakymasID',
    name: 'krepselisntr',
    props: { ntrpaslaugos: true },
    meta: {
      title: 'Krepšelis',
      open: true,
    },
    component: () => import('@/views/Krepselis.vue'),
  },
  {
    path: '/ntr-registras/:registrasNr',
    name: 'ntr-registras',
    meta: {
      title: 'NTR Registras',
      open: true,
    },
    component: () => import('@/views/NtrRegistras.vue'),
  },
  {
    path: '/sutikimas',
    name: 'sutikimas',
    meta: {
      title: 'Sutikimas su sąlygomis',
      open: true,
    },
    component: () => import('@/views/auth/Sutikimas.vue'),
  },
  {
    path: '/sign/:objektasID',
    name: 'sign',
    redirect: to => ({
      name: 'hipotekaRegistravimas',
      params: { ...to.params, sign: true },
    }),
  },
  {
    path: '/ntr-paslaugos/ntr-sign/:prasymasTipas/:prasymasID',
    name: 'ntrsign',
    component: () => import('@/components/ntrpaslaugos/NtrSign.vue'),
  },
  {
    path: '/gautas-pranesimas/:pranesimas',
    name: 'gautasPranesimas',
    props: { ntrpaslaugos: false },
    meta: {
      title: 'Gautas pranešimas',
      open: true,
    },
    component: () => import('@/views/GautasPranesimas.vue'),
  },
  {
    path: '/gautas-ntr-pranesimas/:pranesimas',
    name: 'gautasNtrPranesimasRedirect',
    props: { ntrpaslaugos: true, isRedirect: true },
    meta: {
      title: 'Gautas pranešimas',
      open: true,
    },
    component: () => import('@/views/GautasPranesimas.vue'),
  },
  {
    path: '/ntr-paslaugos/gautas-pranesimas/:pranesimas',
    name: 'gautasNtrPranesimas',
    props: { ntrpaslaugos: true },
    meta: {
      title: 'Gautas pranešimas',
      open: true,
    },
    component: () => import('@/views/GautasPranesimas.vue'),
  },

  {
    path: '/',
    name: 'home',
    component: LayoutSavitarna,
    meta: {
      title: 'Pradžia',
      group: 'apps',
    },
    redirect: { name: 'paslaugos' },
    children: [
      {
        path: '/paslaugos',
        name: 'paslaugos',
        component: () =>
          import('@/components/savitarna/SavitarnaDashboard.vue'),
        meta: {
          title: 'Paslaugos',
          group: 'apps',
          menuTooltip: 'Aprašymas. Meniu. Savitarna paslaugos',
        },
      },
      {
        path: '/pranesimai',
        name: 'pranesimai',
        component: () =>
          import('@/components/savitarna/SavitarnaPranesimai.vue'),
        meta: {
          title: 'Gauti pranešimai',
          group: 'apps',
          menuTooltip: 'Aprašymas. Meniu. Savitarna gauti pranešimai',
        },
      },
      {
        path: '/dokumentai',
        name: 'dokumentai',
        component: () =>
          import('@/components/savitarna/SavitarnaDokumentai.vue'),
        meta: {
          title: 'Mano dokumentai',
          group: 'apps',
          menuTooltip: 'Aprašymas. Meniu. Savitarna mano dokumentai',
        },
      },
      {
        path: '/paieska',
        name: 'savPaieskaTab',
        component: () => import('@/components/paieska/SavPaieskaTab.vue'),
        redirect: { name: 'savPaieskaMano' },
        meta: {
          title: 'Paieškos',
          group: 'apps',
          menuTooltip: 'Aprašymas. Meniu. Savitarna paieška',
        },
        children: [
          {
            path: 'juridinis',
            name: 'savPaieskaJuridinis',
            meta: {
              title: 'Pagal juridinį asmenį',
              menuTooltip: 'Aprašymas. Meniu. Savitarna paieška',
            },
          },
          {
            path: 'fizinis',
            name: 'savPaieskaFizinis',
            meta: {
              title: 'Pagal fizinį asmenį',
              menuTooltip: 'Aprašymas. Meniu. Savitarna paieška',
            },
          },
          {
            path: 'turtas',
            name: 'savPaieskaTurtas',
            meta: {
              title: 'Pagal turtą',
              menuTooltip: 'Aprašymas. Meniu. Savitarna paieška',
            },
          },
          {
            path: 'kodas',
            name: 'savPaieskaKodas',
            meta: {
              title: 'Pagal identifikacinį kodą',
              menuTooltip: 'Aprašymas. Meniu. Savitarna paieška',
            },
          },
          {
            path: 'mano-paieskos',
            name: 'savPaieskaMano',
            meta: {
              title: 'Mano paieškos',
              menuTooltip: 'Aprašymas. Meniu. Savitarna paieška',
            },
          },
        ],
      },
      {
        path: '/dokumentas/:objektasID',
        name: 'hipotekaTab',
        component: () => import('@/components/hipoteka/HipotekaTab.vue'),
        redirect: { name: 'hipotekaPranesimas' },
        meta: {
          title: ':hipotekaTipas',
        },
        children: [
          {
            path: 'dokumento-duomenys',
            name: 'hipotekaPranesimas',
            meta: {
              title: 'Dokumento duomenys',
            },
          },
          {
            path: 'duomenu-teikejas',
            name: 'hipotekaTeikejas',
            meta: {
              title: 'Duomenų teikėjas',
            },
          },
          {
            path: 'skolininkai',
            name: 'hipotekaSkolininkai',
            meta: {
              title: 'Skolininkai',
            },
          },
          {
            path: 'ikaito-davejai',
            name: 'hipotekaIkaitoDavejai',
            meta: {
              title: 'Įkaito davėjai',
            },
          },
          {
            path: 'ikaito-davejai-hr',
            name: 'hipotekaIkaitoDavejaiHR',
            meta: {
              title: 'Įkaito davėjai iš HR',
            },
          },
          {
            path: 'kreditoriai',
            name: 'hipotekaKreditoriai',
            meta: {
              title: 'Kreditoriai',
            },
          },
          {
            path: 'turtas',
            name: 'hipotekaTurtas',
            meta: {
              title: ':turtasTitle',
            },
            children: [
              {
                path: ':turtasRusis/:turtasID',
                name: 'turtasObjektas',
                meta: {
                  title: 'Turtas',
                },
              },
            ],
          },
          {
            path: 'prievole',
            name: 'hipotekaPrievole',
            meta: {
              title: ':prievoleTitle',
            },
            children: [
              {
                path: ':prievoleID',
                name: 'prievoleObjektas',
                meta: {
                  title: 'Duomenys',
                },
              },
            ],
          },
          {
            path: 'sandoris',
            name: 'hipotekaSandoris',
            meta: {
              title: 'Sandorio informacija',
            },
          },
          {
            path: 'nustatymas',
            name: 'hipotekaNustatymas',
            meta: {
              title: 'Nustatymo informacija',
            },
          },
          {
            path: 'vykdomasis',
            name: 'hipotekaVykdomasis',
            meta: {
              title: 'Notaro vykdomasis įrašas',
            },
          },
          {
            path: 'salygos',
            name: 'hipotekaSalyginis',
            meta: {
              title: ':salyginisTitle',
            },
          },
          {
            path: 'kita-informacija',
            name: 'hipotekaKitaInfo',
            meta: {
              title: 'Kita informacija',
            },
          },
          {
            path: 'sutarties-salys',
            name: 'sutartisSalys',
            meta: {
              title: 'Sutarties šalys',
            },
          },
          {
            path: 'sutarties-informacija',
            name: 'sutartisInfo',
            meta: {
              title: 'Sutarties šalys',
            },
          },
          {
            path: 'sutarties-dalykas',
            name: 'sutartisDaiktas',
            meta: {
              title: 'Sutarties dalykas',
            },
          },
          {
            path: 'rinkmenos',
            name: 'hipotekaRinkmenos',
            meta: {
              title: 'Rinkmenos',
            },
          },
          {
            path: 'informavimas',
            name: 'hipotekaInformavimas',
            meta: {
              title: 'Informavimas',
            },
          },
          {
            path: 'registrui',
            name: 'hipotekaRegistravimas',
            meta: {
              title: 'Registravimas',
            },
          },
        ],
      },

      {
        path: '/404',
        name: '404',
        meta: {
          title: 'Puslapis nerastas',
        },
        component: () => import('@/views/error/NotFound.vue'),
      },
      {
        path: '/500',
        name: '500',
        meta: {
          title: 'Serverio klaida',
        },
        component: () => import('@/views/error/Error.vue'),
      },
      {
        path: '/403',
        name: 'Deny',
        component: () => import('@/views/error/Deny.vue'),
        meta: {
          title: 'Prieiga uždrausta',
          hiddenInMenu: false,
        },
      },
    ],
  },
  {
    path: '/ntr-paslaugos',
    name: 'ntrpaslaugos',
    component: LayoutNtrPaslaugos,
    meta: {
      title: 'Prašymai dėl juridinių faktų',
      group: 'apps',
      hidePath: true,
    },
    redirect: { name: 'ntrPrasymai' },
    children: [
      {
        path: 'prasymai',
        name: 'ntrPrasymai',
        component: () => import('@/components/ntrpaslaugos/NtrPrasymai.vue'),
        meta: {
          title: 'Prašymai dėl juridinių faktų',
          group: 'apps',
          hidePath: true,
          menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
        },
      },
      {
        path: 'pazyma',
        name: 'pazyma',
        component: () => import('@/components/layouts/RouteWrapper.vue'),
        meta: {
          title: 'Pažyma',
          hidePath: true,
        },
        redirect: { name: 'pazymaMeniu' },
        children: [
          {
            path: 'sarasas',
            name: 'pazymaMeniu',
            component: () => import('@/components/pazyma/PazymosMeniu.vue'),
            meta: {
              title: 'Pažymos apie ŽŪ / MŪ paskirties žemes',
              hidePath: true,
              menuTooltip:
                'Aprašymas. Meniu. Pažyma apie ŽŪ / MŪ paskirties žemes',
            },
          },
          {
            path: 'zemes-ukio',
            name: 'pazymosZemesUkio',
            component: () => import('@/components/pazyma/Pazymos.vue'),
            props: { pazymaKodas: 'zemes-ukio' },
            meta: {
              title: 'Pažyma apie žemės ūkio paskirties žemę',
              hidePath: false,
              menuTooltip:
                'Aprašymas. Meniu. Pažyma apie ŽŪ / MŪ paskirties žemes',
            },
          },
          {
            path: 'zemes-ukio/:pazymaID',
            name: 'pazymaZemesUkio',
            component: () => import('@/components/pazyma/Pazyma.vue'),
            props: { pazymaKodas: 'zemes-ukio' },
            meta: {
              title: 'Pažyma apie žemės ūkio paskirties žemę',
              hidePath: true,
              menuTooltip:
                'Aprašymas. Meniu. Pažyma apie ŽŪ / MŪ paskirties žemes',
            },
          },
          {
            path: 'misku-ukio',
            name: 'pazymosMiskuUkio',
            component: () => import('@/components/pazyma/Pazymos.vue'),
            props: { pazymaKodas: 'misku-ukio' },
            meta: {
              title: 'Pažyma apie miškų ūkio paskirties žemę',
              hidePath: false,
              menuTooltip:
                'Aprašymas. Meniu. Pažyma apie ŽŪ / MŪ paskirties žemes',
            },
          },
          {
            path: 'misku-ukio/:pazymaID',
            name: 'pazymaMiskuUkio',
            component: () => import('@/components/pazyma/Pazyma.vue'),
            props: { pazymaKodas: 'misku-ukio' },
            meta: {
              title: 'Pažyma apie miškų ūkio paskirties žemę',
              hidePath: true,
              menuTooltip:
                'Aprašymas. Meniu. Pažyma apie ŽŪ / MŪ paskirties žemes',
            },
          },
          {
            path: 'sklypas',
            redirect: { name: 'pazymosZemesSklypas' },
          },
          {
            path: 'zemes-sklypas',
            name: 'pazymosZemesSklypas',
            component: () => import('@/components/pazyma/Pazymos.vue'),
            props: { pazymaKodas: 'zemes-sklypas' },
            meta: {
              title: 'Žemės sklypo planas',
              hidePath: false,
              menuTooltip: 'Aprašymas. Meniu. Žemės sklypo planas',
            },
          },
          {
            path: 'zemes-sklypas/sklypai',
            name: 'pazymaSklypasTurtas',
            component: () => import('@/components/pazyma/SklypasTurtas.vue'),
            props: { pazymaKodas: 'zemes-sklypas' },
            meta: {
              title: 'Žemės sklypo planas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Žemės sklypo planas',
            },
          },
          {
            path: 'zemes-sklypas/:pazymaID',
            name: 'pazymaZemesSklypas',
            component: () => import('@/components/pazyma/Pazyma.vue'),
            props: { pazymaKodas: 'zemes-sklypas' },
            meta: {
              title: 'Žemės sklypo planas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Žemės sklypo planas',
            },
          },
        ],
      },
      {
        path: 'seimos-turtas',
        name: 'seimosTurtas',
        component: () => import('@/components/layouts/RouteWrapper.vue'),
        meta: {
          title: 'Šeimos turtas',
          hidePath: true,
        },
        redirect: { name: 'seimaIregistravimasList' },
        children: [
          {
            path: 'iregistravimas',
            name: 'seimaIregistravimasList',
            component: () =>
              import('@/components/ntrpaslaugos/SeimaIregistravimas.vue'),
            meta: {
              title: 'Šeimos turto įregistravimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'iregistravimas/:prasymasID',
            name: 'seimaIregistravimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/SeimaPrasymas.vue'),
            meta: {
              title: 'Šeimos turto įregistravimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'seimaIregistravimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: ':step?',
                name: 'seimaIregistravimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
          {
            path: 'perkelimas',
            name: 'seimaPerkelimasList',
            component: () =>
              import('@/components/ntrpaslaugos/SeimaPerkelimas.vue'),
            meta: {
              title: 'Šeimos turto perkėlimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'perkelimas/:prasymasID',
            name: 'seimaPerkelimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/SeimaPrasymas.vue'),
            meta: {
              title: 'Šeimos turto perkėlimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'seimaPerkelimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: 'step/:step',
                name: 'seimaPerkelimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
          {
            path: 'isregistravimas',
            name: 'seimaIsregistravimasList',
            component: () =>
              import('@/components/ntrpaslaugos/SeimaIsregistravimas.vue'),
            meta: {
              title: 'Šeimos turto išregistravimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'isregistravimas/:prasymasID',
            name: 'seimaIsregistravimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/SeimaPrasymas.vue'),
            meta: {
              title: 'Šeimos turto išregistravimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'seimaIsregistravimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: 'step/:step',
                name: 'seimaIsregistravimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'bendra-nuosavybe',
        name: 'bendraNuosavybe',
        component: () => import('@/components/layouts/RouteWrapper.vue'),
        meta: {
          title: 'Bendra nuosavybė',
          hidePath: true,
          menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
        },
        redirect: { name: 'bendraIregistravimasList' },
        children: [
          {
            path: 'iregistravimas',
            name: 'bendraIregistravimasList',
            component: () =>
              import('@/components/ntrpaslaugos/BendraIregistravimas.vue'),
            meta: {
              title: 'Bendrosios nuosavybės įregistravimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'iregistravimas/:prasymasID',
            name: 'bendraIregistravimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/BendraPrasymas.vue'),
            meta: {
              title: 'Bendrosios nuosavybės įregistravimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'bendraIregistravimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: ':step?',
                name: 'bendraIregistravimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'nuomos-sutartis',
        name: 'nuomaSutartis',
        component: () => import('@/components/layouts/RouteWrapper.vue'),
        meta: {
          title: 'Nuomos sutartis',
          hidePath: true,
          menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
        },
        redirect: { name: 'nuomaIregistravimasList' },
        children: [
          {
            path: 'sudarymas',
            name: 'nuomaIregistravimasList',
            component: () =>
              import('@/components/ntrpaslaugos/NuomaIregistravimas.vue'),
            meta: {
              title: 'Nuomos sutarties sudarymas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'sudarymas/:prasymasID',
            name: 'nuomaIregistravimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/NuomaPrasymas.vue'),
            meta: {
              title: 'Nuomos sutarties sudarymas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'nuomaIregistravimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: ':step?',
                name: 'nuomaIregistravimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
          {
            path: 'nutraukimas',
            name: 'nuomaNutraukimasList',
            component: () =>
              import('@/components/ntrpaslaugos/NuomaNutraukimas.vue'),
            meta: {
              title: 'Nuomos sutarties nutraukimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'nutraukimas/:prasymasID',
            name: 'nuomaNutraukimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/NuomaPrasymas.vue'),
            meta: {
              title: 'Nuomos sutarties nutraukimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'nuomaNutraukimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: 'step/:step',
                name: 'nuomaNutraukimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
          {
            path: 'isregistravimas',
            name: 'nuomaIsregistravimasList',
            component: () =>
              import('@/components/ntrpaslaugos/NuomaIsregistravimas.vue'),
            meta: {
              title: 'Nuomos sutarties išregistravimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'isregistravimas/:prasymasID',
            name: 'nuomaIsregistravimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/NuomaPrasymas.vue'),
            meta: {
              title: 'Nuomos sutarties išregistravimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'nuomaIsregistravimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: 'step/:step',
                name: 'nuomaIsregistravimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'panaudos-sutartis',
        name: 'panaudaSutartis',
        component: () => import('@/components/layouts/RouteWrapper.vue'),
        meta: {
          title: 'Panaudos sutartis',
          hidePath: true,
          menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
        },
        redirect: { name: 'panaudaIregistravimasList' },
        children: [
          {
            path: 'sudarymas',
            name: 'panaudaIregistravimasList',
            component: () =>
              import('@/components/ntrpaslaugos/PanaudaIregistravimas.vue'),
            meta: {
              title: 'Panaudos sutarties sudarymas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'sudarymas/:prasymasID',
            name: 'panaudaIregistravimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/PanaudaPrasymas.vue'),
            meta: {
              title: 'Panaudos sutarties sudarymas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'panaudaIregistravimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: ':step?',
                name: 'panaudaIregistravimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
          {
            path: 'nutraukimas',
            name: 'panaudaNutraukimasList',
            component: () =>
              import('@/components/ntrpaslaugos/PanaudaNutraukimas.vue'),
            meta: {
              title: 'Panaudos sutarties nutraukimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'nutraukimas/:prasymasID',
            name: 'panaudaNutraukimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/PanaudaPrasymas.vue'),
            meta: {
              title: 'Panaudos sutarties nutraukimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'panaudaNutraukimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: 'step/:step',
                name: 'panaudaNutraukimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
          {
            path: 'isregistravimas',
            name: 'panaudaIsregistravimasList',
            component: () =>
              import('@/components/ntrpaslaugos/PanaudaIsregistravimas.vue'),
            meta: {
              title: 'Panaudos sutarties išregistravimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'isregistravimas/:prasymasID',
            name: 'panaudaIsregistravimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/PanaudaPrasymas.vue'),
            meta: {
              title: 'Panaudos sutarties išregistravimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'panaudaIsregistravimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: 'step/:step',
                name: 'panaudaIsregistravimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'subnuomos-sutartis',
        name: 'subnuomaSutartis',
        component: () => import('@/components/layouts/RouteWrapper.vue'),
        meta: {
          title: 'Subnuomos sutartis',
          hidePath: true,
          menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
        },
        redirect: { name: 'subnuomaIregistravimasList' },
        children: [
          {
            path: 'sudarymas',
            name: 'subnuomaIregistravimasList',
            component: () =>
              import('@/components/ntrpaslaugos/SubnuomaIregistravimas.vue'),
            meta: {
              title: 'Subnuomos sutarties sudarymas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'sudarymas/:prasymasID',
            name: 'subnuomaIregistravimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/SubnuomaPrasymas.vue'),
            meta: {
              title: 'Subnuomos sutarties sudarymas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'subnuomaIregistravimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: ':step?',
                name: 'subnuomaIregistravimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
          {
            path: 'nutraukimas',
            name: 'subnuomaNutraukimasList',
            component: () =>
              import('@/components/ntrpaslaugos/SubnuomaNutraukimas.vue'),
            meta: {
              title: 'Subnuomos sutarties nutraukimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'nutraukimas/:prasymasID',
            name: 'subnuomaNutraukimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/SubnuomaPrasymas.vue'),
            meta: {
              title: 'Subnuomos sutarties nutraukimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'subnuomaNutraukimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: 'step/:step',
                name: 'subnuomaNutraukimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
          {
            path: 'isregistravimas',
            name: 'subnuomaIsregistravimasList',
            component: () =>
              import('@/components/ntrpaslaugos/SubnuomaIsregistravimas.vue'),
            meta: {
              title: 'Nuomos sutarties išregistravimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'isregistravimas/:prasymasID',
            name: 'subnuomaIsregistravimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/SubnuomaPrasymas.vue'),
            meta: {
              title: 'Subnuomos sutarties išregistravimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'subnuomaIsregistravimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: 'step/:step',
                name: 'subnuomaIsregistravimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'preliminarioji-sutartis',
        name: 'preliminariSutartis',
        component: () => import('@/components/layouts/RouteWrapper.vue'),
        meta: {
          title: 'Preliminarioji sutartis',
          hidePath: true,
          menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
        },
        redirect: { name: 'preliminariIregistravimasList' },
        children: [
          {
            path: 'sudarymas',
            name: 'preliminariIregistravimasList',
            component: () =>
              import('@/components/ntrpaslaugos/PreliminariIregistravimas.vue'),
            meta: {
              title: 'Preliminariosios sutarties sudarymas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'sudarymas/:prasymasID',
            name: 'preliminariIregistravimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/PreliminariPrasymas.vue'),
            meta: {
              title: 'Preliminariosios sutarties sudarymas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'preliminariIregistravimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: ':step?',
                name: 'preliminariIregistravimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
          {
            path: 'nutraukimas',
            name: 'preliminariNutraukimasList',
            component: () =>
              import('@/components/ntrpaslaugos/PreliminariNutraukimas.vue'),
            meta: {
              title: 'Preliminariosios sutarties nutraukimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'nutraukimas/:prasymasID',
            name: 'preliminariNutraukimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/PreliminariPrasymas.vue'),
            meta: {
              title: 'Preliminariosios sutarties nutraukimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'preliminariNutraukimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: 'step/:step',
                name: 'preliminariNutraukimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
          {
            path: 'isregistravimas',
            name: 'preliminariIsregistravimasList',
            component: () =>
              import(
                '@/components/ntrpaslaugos/PreliminariIsregistravimas.vue'
              ),
            meta: {
              title: 'Preliminariosios sutarties išregistravimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
          },
          {
            path: 'isregistravimas/:prasymasID',
            name: 'preliminariIsregistravimasPrasymas',
            component: () =>
              import('@/components/ntrpaslaugos/PreliminariPrasymas.vue'),
            meta: {
              title: 'Preliminariosios sutarties išregistravimas',
              hidePath: true,
              menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
            },
            redirect: to => ({
              name: 'preliminariIsregistravimasSteps',
              params: { ...to.params, step: 'asmenys' },
            }),
            children: [
              {
                path: 'step/:step',
                name: 'preliminariIsregistravimasSteps',
                meta: {
                  title: 'Duomenys',
                  hidePath: true,
                  menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'dokumentai',
        name: 'ntrDokumentai',
        component: () => import('@/components/ntrpaslaugos/NtrDokumentai.vue'),
        meta: {
          title: 'Dokumentų sąrašas',
          group: 'apps',
          hidePath: true,
          menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
        },
      },
      {
        path: 'pranesimai',
        name: 'ntrGautiPranesimai',
        component: () => import('@/components/ntrpaslaugos/NtrPranesimai.vue'),
        meta: {
          title: 'Gauti pranešimai',
          group: 'apps',
          hidePath: true,
          menuTooltip: 'Aprašymas. Meniu. Prašymai dėl juridinių faktų',
        },
      },
    ],
  },
]
